































































































































































import { Component, Prop, Watch, Vue } from "vue-property-decorator";
import VueRouter from "vue-router";
import Sling from "@/classes/Sling";

@Component({
    components: {},
})
export default class Home extends Vue {
    sling: Sling | null = null;

    mounted() {
        this.sling = new Sling();

        /*
        this.sling.targetWeightCode = "2";
        this.sling.targetNumberCode = "4";
        this.sling.wireCode = "1";
        this.sling.wireLengthCode = "11";
        this.sling.ringCode = "A02";
        this.sling.hookCode = "A02";
        */
    }

    get linkDon() {
        return Sling.linkDon;
    }

    get weightOptions() {
        if (!this.sling) return [];

        const options = [];

        for (const code in this.sling.targetWeights) {
            const value = this.sling.targetWeights[code];

            options.push({
                text: value,
                value: code,
            });
        }

        return options;
    }

    get numberOptions() {
        if (!this.sling) return [];

        const options = [];

        for (const code in this.sling.targetNumbers) {
            const value = this.sling.targetNumbers[code];

            options.push({
                text: value,
                value: code,
            });
        }

        return options;
    }

    get wireOptions() {
        if (!this.sling) return [];

        const options = [];

        for (const code in this.sling.wires) {
            const value = this.sling.wires[code];

            options.push({
                text: value,
                value: code,
            });
        }

        return options;
    }

    get lengthOptions() {
        if (!this.sling) return [];

        const options = [];

        for (const code in this.sling.wireLengths) {
            const value = this.sling.wireLengths[code];

            options.push({
                text: value,
                value: code,
            });
        }

        return options;
    }

    get ringOptions() {
        if (!this.sling) return [];

        const sling = this.sling;

        return this.sling.ringCodes.map((code) => {
            if (code in sling.ringSpecs) {
                return {
                    text: sling.ringSpecs[code]["name"],
                    value: code,
                };
            }
        });
    }

    get hookOptions() {
        if (!this.sling) return [];

        const sling = this.sling;

        return this.sling.hookCodes.map((code) => {
            if (code in sling.hookSpecs) {
                return {
                    text: sling.hookSpecs[code]["name"],
                    value: code,
                };
            }
        });
    }
}
